module.exports = {
	"config": {
		"siteTitle": "React-MDL: React Components for Material Design Lite",
		"linkPrefix": "/react-mdl",
		"componentPages": [
			"/components/badge/",
			"/components/button/",
			"/components/card/",
			"/components/checkbox/",
			"/components/chip/",
			"/components/datatable/",
			"/components/dialog/",
			"/components/grid/",
			"/components/icon-toggle/",
			"/components/layout/",
			"/components/list/",
			"/components/menu/",
			"/components/progress-bar/",
			"/components/radio-button/",
			"/components/slider/",
			"/components/snackbar/",
			"/components/spinner/",
			"/components/switch/",
			"/components/tabs/",
			"/components/textfield/",
			"/components/tooltip/"
		],
		"templatePages": [
			"/templates/article/",
			"/templates/text/"
		]
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "components",
				"stem": "_template",
				"path": "components/_template.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/_template.js",
				"isAbsolute": false
			},
			"requirePath": "components/_template.js",
			"templatePath": "/components/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "badge.md",
				"ext": "md",
				"name": "badge",
				"extname": ".md",
				"basename": "badge.md",
				"dirname": "components",
				"stem": "badge",
				"path": "components/badge.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/badge.md",
				"isAbsolute": false
			},
			"requirePath": "components/badge.md",
			"path": "/components/badge/",
			"data": {
				"title": "Badge"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "button.md",
				"ext": "md",
				"name": "button",
				"extname": ".md",
				"basename": "button.md",
				"dirname": "components",
				"stem": "button",
				"path": "components/button.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/button.md",
				"isAbsolute": false
			},
			"requirePath": "components/button.md",
			"path": "/components/button/",
			"data": {
				"title": "Buttons"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "card.md",
				"ext": "md",
				"name": "card",
				"extname": ".md",
				"basename": "card.md",
				"dirname": "components",
				"stem": "card",
				"path": "components/card.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/card.md",
				"isAbsolute": false
			},
			"requirePath": "components/card.md",
			"path": "/components/card/",
			"data": {
				"title": "Cards"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "checkbox.md",
				"ext": "md",
				"name": "checkbox",
				"extname": ".md",
				"basename": "checkbox.md",
				"dirname": "components",
				"stem": "checkbox",
				"path": "components/checkbox.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/checkbox.md",
				"isAbsolute": false
			},
			"requirePath": "components/checkbox.md",
			"path": "/components/checkbox/",
			"data": {
				"title": "Checkbox"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "chip.md",
				"ext": "md",
				"name": "chip",
				"extname": ".md",
				"basename": "chip.md",
				"dirname": "components",
				"stem": "chip",
				"path": "components/chip.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/chip.md",
				"isAbsolute": false
			},
			"requirePath": "components/chip.md",
			"path": "/components/chip/",
			"data": {
				"title": "Chip"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "datatable.md",
				"ext": "md",
				"name": "datatable",
				"extname": ".md",
				"basename": "datatable.md",
				"dirname": "components",
				"stem": "datatable",
				"path": "components/datatable.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/datatable.md",
				"isAbsolute": false
			},
			"requirePath": "components/datatable.md",
			"path": "/components/datatable/",
			"data": {
				"title": "DataTable"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "dialog.md",
				"ext": "md",
				"name": "dialog",
				"extname": ".md",
				"basename": "dialog.md",
				"dirname": "components",
				"stem": "dialog",
				"path": "components/dialog.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/dialog.md",
				"isAbsolute": false
			},
			"requirePath": "components/dialog.md",
			"path": "/components/dialog/",
			"data": {
				"title": "Dialog"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "grid.md",
				"ext": "md",
				"name": "grid",
				"extname": ".md",
				"basename": "grid.md",
				"dirname": "components",
				"stem": "grid",
				"path": "components/grid.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/grid.md",
				"isAbsolute": false
			},
			"requirePath": "components/grid.md",
			"path": "/components/grid/",
			"data": {
				"title": "Grid"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "icon-toggle.md",
				"ext": "md",
				"name": "icon-toggle",
				"extname": ".md",
				"basename": "icon-toggle.md",
				"dirname": "components",
				"stem": "icon-toggle",
				"path": "components/icon-toggle.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/icon-toggle.md",
				"isAbsolute": false
			},
			"requirePath": "components/icon-toggle.md",
			"path": "/components/icon-toggle/",
			"data": {
				"title": "Icon Toggle"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "components",
				"stem": "index",
				"path": "components/index.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/index.md",
				"isAbsolute": false
			},
			"requirePath": "components/index.md",
			"path": "/components/",
			"data": {
				"title": "Components"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "layout.md",
				"ext": "md",
				"name": "layout",
				"extname": ".md",
				"basename": "layout.md",
				"dirname": "components",
				"stem": "layout",
				"path": "components/layout.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/layout.md",
				"isAbsolute": false
			},
			"requirePath": "components/layout.md",
			"path": "/components/layout/",
			"data": {
				"title": "Layout"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "list.md",
				"ext": "md",
				"name": "list",
				"extname": ".md",
				"basename": "list.md",
				"dirname": "components",
				"stem": "list",
				"path": "components/list.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/list.md",
				"isAbsolute": false
			},
			"requirePath": "components/list.md",
			"path": "/components/list/",
			"data": {
				"title": "List"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "menu.md",
				"ext": "md",
				"name": "menu",
				"extname": ".md",
				"basename": "menu.md",
				"dirname": "components",
				"stem": "menu",
				"path": "components/menu.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/menu.md",
				"isAbsolute": false
			},
			"requirePath": "components/menu.md",
			"path": "/components/menu/",
			"data": {
				"title": "Menu"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "progress-bar.md",
				"ext": "md",
				"name": "progress-bar",
				"extname": ".md",
				"basename": "progress-bar.md",
				"dirname": "components",
				"stem": "progress-bar",
				"path": "components/progress-bar.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/progress-bar.md",
				"isAbsolute": false
			},
			"requirePath": "components/progress-bar.md",
			"path": "/components/progress-bar/",
			"data": {
				"title": "Progress Bar"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "radio-button.md",
				"ext": "md",
				"name": "radio-button",
				"extname": ".md",
				"basename": "radio-button.md",
				"dirname": "components",
				"stem": "radio-button",
				"path": "components/radio-button.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/radio-button.md",
				"isAbsolute": false
			},
			"requirePath": "components/radio-button.md",
			"path": "/components/radio-button/",
			"data": {
				"title": "Radio Button"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "slider.md",
				"ext": "md",
				"name": "slider",
				"extname": ".md",
				"basename": "slider.md",
				"dirname": "components",
				"stem": "slider",
				"path": "components/slider.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/slider.md",
				"isAbsolute": false
			},
			"requirePath": "components/slider.md",
			"path": "/components/slider/",
			"data": {
				"title": "Slider"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "snackbar.md",
				"ext": "md",
				"name": "snackbar",
				"extname": ".md",
				"basename": "snackbar.md",
				"dirname": "components",
				"stem": "snackbar",
				"path": "components/snackbar.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/snackbar.md",
				"isAbsolute": false
			},
			"requirePath": "components/snackbar.md",
			"path": "/components/snackbar/",
			"data": {
				"title": "Snackbar"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "spinner.md",
				"ext": "md",
				"name": "spinner",
				"extname": ".md",
				"basename": "spinner.md",
				"dirname": "components",
				"stem": "spinner",
				"path": "components/spinner.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/spinner.md",
				"isAbsolute": false
			},
			"requirePath": "components/spinner.md",
			"path": "/components/spinner/",
			"data": {
				"title": "Spinner"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "switch.md",
				"ext": "md",
				"name": "switch",
				"extname": ".md",
				"basename": "switch.md",
				"dirname": "components",
				"stem": "switch",
				"path": "components/switch.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/switch.md",
				"isAbsolute": false
			},
			"requirePath": "components/switch.md",
			"path": "/components/switch/",
			"data": {
				"title": "Switch"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "tabs.md",
				"ext": "md",
				"name": "tabs",
				"extname": ".md",
				"basename": "tabs.md",
				"dirname": "components",
				"stem": "tabs",
				"path": "components/tabs.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/tabs.md",
				"isAbsolute": false
			},
			"requirePath": "components/tabs.md",
			"path": "/components/tabs/",
			"data": {
				"title": "Tabs"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "textfield.md",
				"ext": "md",
				"name": "textfield",
				"extname": ".md",
				"basename": "textfield.md",
				"dirname": "components",
				"stem": "textfield",
				"path": "components/textfield.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/textfield.md",
				"isAbsolute": false
			},
			"requirePath": "components/textfield.md",
			"path": "/components/textfield/",
			"data": {
				"title": "Textfield"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "components",
				"base": "tooltip.md",
				"ext": "md",
				"name": "tooltip",
				"extname": ".md",
				"basename": "tooltip.md",
				"dirname": "components",
				"stem": "tooltip",
				"path": "components/tooltip.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/components/tooltip.md",
				"isAbsolute": false
			},
			"requirePath": "components/tooltip.md",
			"path": "/components/tooltip/",
			"data": {
				"title": "Tooltip"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "templates",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "templates",
				"stem": "_template",
				"path": "templates/_template.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/templates/_template.js",
				"isAbsolute": false
			},
			"requirePath": "templates/_template.js",
			"templatePath": "/templates/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "templates",
				"base": "_templateHelper.js",
				"ext": "js",
				"name": "_templateHelper",
				"extname": ".js",
				"basename": "_templateHelper.js",
				"dirname": "templates",
				"stem": "_templateHelper",
				"path": "templates/_templateHelper.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/templates/_templateHelper.js",
				"isAbsolute": false
			},
			"requirePath": "templates/_templateHelper.js",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "templates/article",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "templates/article",
				"stem": "index",
				"path": "templates/article/index.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/templates/article/index.js",
				"isAbsolute": false
			},
			"requirePath": "templates/article/index.js",
			"path": "/templates/article/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "templates",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "templates",
				"stem": "index",
				"path": "templates/index.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/templates/index.js",
				"isAbsolute": false
			},
			"requirePath": "templates/index.js",
			"path": "/templates/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "templates/text",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "templates/text",
				"stem": "index",
				"path": "templates/text/index.js",
				"absolute": "/Users/tleunen/dev/react-mdl/docs/templates/text/index.js",
				"isAbsolute": false
			},
			"requirePath": "templates/text/index.js",
			"path": "/templates/text/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 381
// module chunks = 0